module.exports = __webpack_public_path__ + "static/media/p0_3.80f0de58.png";